module.exports = __webpack_public_path__ + "img/v1.0.a0501aea.png";